<div class="container" *ngIf="theme$ | async as theme">
  <div class="main-container-export">
    <p-accordion [(value)]="activeIndex" [dt]="exportAccordion">
      <p-accordion-panel value="0" >
        <p-accordion-header>
          <div class="header top">
            <div class="row-icon export">
              <i class="pi pi-file-export"></i>
            </div>
            <span>Export</span>
          </div>
        </p-accordion-header>
        <p-accordion-content 
          [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
          <div>
            <form class="form" [formGroup]="form" (ngSubmit)="onSubmitGetCSV()">
              <div class="note">
                <div>
                  <span [style]="{'font-weight': '600'}">Temporary Limitations: </span>
                  The export feature is limitied to two(2) download
                  requests per hour for all logged in devices.
                </div>
                <div>
                  <span [style]="{'font-weight': '600'}">Note: </span>
                  All date selections, with exception to 'All' and Effective Period' are based on UTC time.
                </div>
              </div>
              <div class="sub-title">Flight Date(s)</div>
              <div class="cb-col">
                <div *ngFor="let checkboxitem of checkboxItems; trackBy: trackById">
                  @if(checkboxitem.id != 5 && checkboxitem.id != 6) {
                  <ng-container *ngTemplateOutlet="default"></ng-container>
                  } @else if(checkboxitem.id === 5) {
                  <ng-container *ngTemplateOutlet="dateRange"></ng-container>
                  } @else {
                  <ng-container *ngTemplateOutlet="effectivePeriod"></ng-container>
                  }

                  <ng-template #default>
                    <label class="custom-checkbox">
                      <input id=checkbox type="checkbox" [formControlName]="checkboxitem.formName"
                        [checked]="isChecked(checkboxitem.id)" (change)="onCheckboxChange(checkboxitem.id, $event)" />
                      {{checkboxitem.name}}
                    </label>
                  </ng-template>

                  <ng-template #dateRange>
                    <div class="custom-cb-container">
                      <label class="custom-checkbox">
                        <input id="checkbox" type="checkbox" [formControlName]="checkboxitem.formName"
                          [checked]="isChecked(checkboxitem.id)" (change)="onCheckboxChange(checkboxitem.id, $event)" />
                        {{checkboxitem.name}}
                      </label>
                      <div [@fadeOpenClose]="form.get('dateRangeCheckBox')?.value ? 'open' : 'closed'">
                        <p-datepicker [dt]="colorPicker" class="export-date-range"appendTo="body" id="dateRange" formControlName="dateRange" selectionMode="range"
                          showButtonBar="true" showClear="true" [maxDate]="calMaxDate"
                          [class.ng-invalid.ng-dirty]="dateRangeValidationError()" />
                        @if(dateRangeValidationError()) {
                        <div class=error-row-alt>
                          <div class="error-msg">End Date Required</div>
                        </div>
                        }
                      </div>
                    </div>
                  </ng-template>
                  <ng-template #effectivePeriod>
                    <div class="custom-cb-container">
                      <label class="custom-checkbox">
                        <input id="checkbox" type="checkbox" [formControlName]="checkboxitem.formName"
                          [checked]="isChecked(checkboxitem.id)" (change)="onCheckboxChange(checkboxitem.id, $event)" />
                        {{checkboxitem.name}}
                      </label>
                      <div [@fadeOpenClose]="form.get('effectivePeriodCheckBox')?.value ? 'open' : 'closed'">
                        <p-datepicker [dt]="colorPicker" class="export-effective-period" appendTo="body" id="effectivePeriod" formControlName="effectivePeriod" view="month"
                          dateFormat="yymm" showButtonBar="true" showClear="true" [maxDate]="calMaxDate"
                          [class.ng-invalid.ng-dirty]="effectivePeriodValidationError()" />
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="button-container" *ngIf="appService.theme$ | async as theme">
                <button class="download-btn" pButton pRipple type="button" [disabled]="!form.valid"
                  (click)="onSubmitGetCSV()">
                  Download
                </button>
              </div>
            </form>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
      <div class="h-divider"></div>
      <p-accordion-panel value="1">
        <p-accordion-header>
          <div class="header">
            <div class="row-icon map">
              <i class="pi pi-map"></i>
            </div>
            <span>Career Map Projection</span>
          </div>
        </p-accordion-header>
        <p-accordion-content
          [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
          <ng-container>
            <div class="map-export-container">
              <div class="note">
                <p>
                  The Career Map Projection option will generate a map projection of All
                  operated flights throughout your career. It does not include any deadhead
                  or cancelled flights. Airport markers for the departure and arrival are
                  automatically included in the map projection and can be toggled on or off
                  within the map view.
                </p>
                <!-- <p>
                  NOTE: In a future release, we will add the ability to export the map as an
                  image file. For now, you can take a screenshot of the map and save it as an
                  image file.
                </p> -->
              </div>
              <h4>Route Color</h4>
              <ul class="note">
                <li><b>Default: </b>Displays a default blue color for all routes</li>
                <li><b>By Aircraft: </b>Displays a different color for each aircraft type operated</li>
                <li><b>Select Color: </b>Allows you to select a custom color for all routes</li>
              </ul>
              <div class="row checkbox">
                <div class="row cursor-pointer">
                  <label class="custom-checkbox">
                    <input type="checkbox" (change)="onMapProjRouteColorDefaultCB($event)"
                      [(ngModel)]="gLineRouteColorDefaultCB" />
                    Default
                  </label>
                </div>
                <div class="row cursor-pointer">
                  <label class="custom-checkbox">
                    <input type="checkbox" (change)="onMapProjRouteColorChangeCB($event)"
                      [(ngModel)]="gLineRouteColorCB" />
                    By Aircraft
                  </label>
                </div>
                <div class="row cursor-pointer">
                  <label class="custom-checkbox">
                    <input type="checkbox" (change)="onMapProjSelectColorCB($event)" [(ngModel)]="gLineSelectColorCB" />
                    Select Color
                  </label>
                  <div class="color-picker">
                    <p-colorPicker [disabled]="!gLineSelectColorCB || gLineRouteColorDefaultCB" appendTo="body"
                      inputId="colorPicker" [(ngModel)]="gLineSelectedColor" />
                  </div>
                </div>
              </div>
              <div class="button-container" *ngIf="appService.theme$ | async as theme">
                <button class="download-btn" pButton pRipple type="button"
                  [disabled]="!gLineRouteColorCB && !gLineSelectColorCB && !gLineRouteColorDefaultCB"
                  (click)="onSubmitGetMapProj()">
                  Generate Map
                </button>
              </div>
            </div>
          </ng-container>
        </p-accordion-content>
      </p-accordion-panel>
      <div class="h-divider"></div>
      <p-accordion-panel value="2">
        <p-accordion-header>
          <div class="header">
            <div class="row-icon globe">
              <i class="pi pi-globe"></i>
            </div>
            <span>Google Earth</span>
          </div>
        </p-accordion-header>
        <p-accordion-content
          [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
          <ng-container>
            <div class="map-export-container">
              <div class="note">
                To create a Google Earth map projection, select the route color
                and the option to include airport markers (optional). Subsequently,
                click “Generate Map.” The KML file will be downloaded to your device,
                where you can save it or utilize cloud storage to open it in Google Earth.
                Deadhead and cancelled flights are not included in the Google Earth map projection.
              </div>
              <h4>Route Color</h4>
              <ul class="note">
                <li><b>Default: </b>Displays a default blue color for all routes</li>
                <li><b>Select Color: </b>Allows you to select a custom color for all routes</li>
              </ul>
              <div class="row checkbox">
                <div class="row cursor-pointer">
                  <label class="custom-checkbox">
                    <input type="checkbox" (change)="onGxMapRouteColorDefaultCB($event)"
                      [(ngModel)]="gxLineRouteColorDefaultCB" />
                    Default Color
                  </label>
                </div>
                <div class="row cursor-pointer">
                  <label class="custom-checkbox">
                    <input type="checkbox" (change)="onGxMapSelectColorCB($event)" [(ngModel)]="gxLineSelectColorCB" />
                    Select Color
                  </label>
                  <div class="color-picker">
                    <p-colorPicker [disabled]="!gxLineSelectColorCB || gxLineRouteColorDefaultCB" appendTo="body"
                      inputId="colorPicker" [(ngModel)]="gxLineSelectedColor" />
                  </div>
                </div>
                <h4>Airport Station Markers</h4>
                <ul class="note">
                  <li><b>IATA Airport Labels: </b>Adds the IATA code for each airport (optional)</li>
                  <li><b>Icon Airport Markers: </b>Adds an aircraft icon for each airport (optional)</li>
                </ul>
                <div class="row cursor-pointer">
                  <label class="custom-checkbox">
                    <input type="checkbox" (change)="toggleMarkers($event)" [(ngModel)]="gxLabelMarkersToggle" />
                    IATA Airport Labels
                  </label>
                </div>
                <div class="row cursor-pointer">
                  <label class="custom-checkbox">
                    <input type="checkbox" (change)="toggleIconMarkers($event)" [(ngModel)]="gxIconMarkersToggle" />
                    Icon Airport Markers
                  </label>
                </div>
              </div>
              <div class="button-container" *ngIf="appService.theme$ | async as theme">
                <button class="download-btn" pButton pRipple type="button"
                  [disabled]="!gxLineSelectColorCB && !gxLineRouteColorDefaultCB" 
                  (click)="onSubmitGetGoogleEarth()">
                  Generate Map
                </button>
              </div>
            </div>
          </ng-container>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
    <div class="download-menu-row" (click)="onCellPress('download')"
      [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
      <div class="download-menu-row-half">
        <div class="row-icon download">
          <i class="pi pi-download"></i>
        </div>
        <div class="download-label">
          Downloads
        </div>
      </div>
      <div class="download-menu-row-half">
        <i class="clickable-row pi pi-chevron-right"></i>
      </div>
    </div>
  </div>
</div>